'use client'
import React, { useEffect, useState } from 'react'
import SeriesScoreCard from '../seriesMatchCard'
import { useLazyQuery } from '@apollo/client'
import { FIXTURES_LIST } from '@/graphql/series/fixtures.query'
import getStatus from '@/shared/hooks/useStatus'
import CustomSelect from '../../customSelect'
import NoData from '../../noData'
import NoMatches from '../../../../assets/images/error-images/noMatchesAvailable.svg'

type scorecardType = {
  _id?: string
  dStartDate: number | Date
  sStatusNote?: string | null
  iBattingTeamId?: string | null
  iWinnerId?: string | null
  nLatestInningNumber: number
  oVenue?: { sLocation?: string }
  sSubtitle?: string
  oSeo?: { sSlug: string }
  oTeamScoreA: { sScoresFull?: string | null; oTeam?: { _id?: string; sTitle?: string; sAbbr?: string; oImg?: { sUrl?: string } } } | null
  oTeamScoreB: { sScoresFull?: string | null; oTeam?: { _id?: string; sTitle?: string; sAbbr?: string; oImg?: { sUrl?: string } } } | null
}

type SeriesFixturesProps = {
  data?: any
  scoreCard?: scorecardType[]
  seriesUrls?: any
  id: string
}

function SeriesFixtures({ data, id }: SeriesFixturesProps) {
  const [payload, setPayload] = useState({ iTeamId: null, iVenueId: null, nOrder: 1, sSortBy: 'dStartDate' })
  const [value, setValue] = useState({ team: undefined, venue: undefined })
  const [flag, setFlag] = useState(0)
  const teams = data?.fetchSeriesData?.aTeams
  const venues = data?.fetchSeriesData?.aVenues

  const [updateFixture, { data: updateFixtureData }] = useLazyQuery(FIXTURES_LIST, {
    variables: {
      input: {
        iSeriesId: id,
        ...payload,
      },
    },
  })

  const updateData = updateFixtureData?.fetchFixuresData

  const handleFilterChange = (e: any, type: any) => {
    if (type === 'team') {
      setPayload({ ...payload, iTeamId: e === null ? null : e.sValue })
    } else {
      setPayload({ ...payload, iVenueId: e === null ? null : e.sValue })
    }
    setValue({ ...value, [type]: e })
    setFlag(1)
  }

  const fixtureData = flag === 0 ? data?.fetchFixuresData?.slice(0) : updateData?.slice(0)
  const fixtureDataLive = fixtureData?.filter((ele: any) => getStatus(ele)?.sStatusStr === 'live')
  const fixtureDataUpcoming = fixtureData?.filter(
    (ele: any) => getStatus(ele)?.sStatusStr !== 'completed' && getStatus(ele)?.sStatusStr === 'scheduled'
  )
  const fixtureDataFinished = fixtureData
    ?.filter((ele: any) => getStatus(ele)?.sStatusStr === 'completed' || getStatus(ele)?.sStatusStr === 'cancelled')
    .reverse()
  const optionTeams = teams?.map((team: any) => ({
    sValue: team._id,
    sLabel: team.sTitle,
  }))

  const optionVenues = venues?.map((venue: any) => ({
    sValue: venue._id,
    sLabel: venue.sName,
  }))

  useEffect(() => {
    if (payload.iTeamId || payload.iVenueId) {
      updateFixture()
    }
  }, [payload])

  return (
    <>
      {fixtureDataLive?.length > 0 || fixtureDataUpcoming?.length > 0 || fixtureDataFinished?.length > 0 ? (
        <div>
          <div className='grid grid-cols-12 gap-4'>
            <CustomSelect
              options={optionTeams}
              value={value.team}
              className='md:col-span-3 col-span-6 '
              controlClass='dark:!bg-transparent bg-white'
              placeholder='Select Team'
              getOptionLabel={(opt: any) => opt?.sLabel}
              getOptionValue={(opt: any) => opt?.sValue}
              isClearable
              isMedium={true}
              onChange={(e) => {
                handleFilterChange(e, 'team')
              }}
            />
            <CustomSelect
              options={optionVenues}
              value={value.venue}
              className='md:col-span-3 col-span-6'
              placeholder='Select Venue'
              controlClass='dark:!bg-transparent bg-white'
              getOptionLabel={(opt: any) => opt?.sLabel}
              getOptionValue={(opt: any) => opt?.sValue}
              isClearable
              isMedium={true}
              onChange={(e: any) => {
                handleFilterChange(e, 'venue')
              }}
            />
          </div>

          {fixtureDataLive?.length > 0 && (
            <>
              <h4 className='text-sm md:text-lg font-bold mb-4 md:mb-6 text-textOffWhite'>Live Matches</h4>
              <div className='md:border-0 dark:border-0 border dark:rounded-none rounded-2xl overflow-hidden border-tabBorder'>
                {fixtureDataLive?.map((score: scorecardType) => {
                  return (
                      <SeriesScoreCard key={score._id} className='!w-full' card={score} />
                  )
                })}
              </div>
            </>
          )}
          {fixtureDataUpcoming?.length > 0 && (
            <>
              <h4 className='text-sm md:text-lg font-bold mb-4 md:mb-6 text-textOffWhite'>Upcoming Matches</h4>
              <div className=' md:border-0 dark:border-0 border dark:rounded-none rounded-2xl overflow-hidden border-tabBorder'>
                {fixtureDataUpcoming?.map((score: scorecardType) => {
                  return (
                      <SeriesScoreCard  key={score._id} className='!w-full' card={score} />
                  )
                })}
              </div>
            </>
          )}
          {fixtureDataFinished?.length > 0 && (
            <>
              <h4 className='text-sm md:text-lg font-bold mt-7 md:mt-10 mb-4 md:mb-6 text-textOffWhite'>Results</h4>
              <div className='md:border-0 dark:border-0 border dark:rounded-none rounded-2xl overflow-hidden border-tabBorder'>
                {fixtureDataFinished?.map((score: scorecardType) => {
                  return (
                      <SeriesScoreCard key={score._id} className='!w-full' card={score} />
                  )
                })}
              </div>
            </>
          )}
        </div>
      ) : (
          <NoData imagePath={NoMatches} title="No fixtures? That’s just the calm before the storm. Get ready for some epic matchups!"/>
      )}
    </>
  )
}

export default SeriesFixtures


